import styled from 'styled-components';

export const ProjectListContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
`;

export const OverflowButtonStyled = styled.div`
  padding-left: 2px;
  margin-top: -1px;
`;
